import { render, staticRenderFns } from "./ExportGroup.vue?vue&type=template&id=54451fed&scoped=true&"
import script from "./ExportGroup.vue?vue&type=script&lang=js&"
export * from "./ExportGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExportGroup.vue?vue&type=style&index=0&id=54451fed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54451fed",
  null
  
)

export default component.exports